/***!
 * @license
 * RSJ 3D Packer Viewer
 * (C) Copyright 2021 by RSJ Software GmbH Stockdorf. All rights reserved.
 **/

import { Engine } from '@babylonjs/core/Engines/engine';

import cuboids from "./data";
import PackScene from "./create";

var loadingDiv = document.getElementById("loading");
loadingDiv.setAttribute("style", "display:none;");

var canvas = document.getElementById("renderCanvas");

var engine = null;
var packScene = null;
var createDefaultEngine = function() { return new Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true }); };

engine = createDefaultEngine();
if (!engine) throw 'engine should not be null.';

engine.runRenderLoop(function () {
    if (packScene) {
        packScene.render();
        }
    });

// Resize
window.addEventListener("resize", function () {
    engine.resize();
    });

var viewerArgs = window.packer3dViewerArgs;

console.log(viewerArgs);

packScene = new PackScene(engine, canvas, null, function(x) { return x;});
packScene.updateScene(viewerArgs.rsp.packedItems, viewerArgs.rsp.usedContainers);

